import React, { useState } from "react";
import ReactHtmlParser from "react-html-parser";
import Tooltip from "src/components/Tooltip";

import * as S from "./styles";
import CustomTooltip from "src/components/Tooltip";
import { addHours, isWithinInterval } from "date-fns";
// import Tooltip from "src/components/Tooltip";

function CardPlan({ item, blur, section, plans }) {
  const [currentTooltip, setCurrentTooltip] = useState("");
  const { benefits, title, price, newPrice } = item.fields;

  const titleFormatted = "Mensalidade por apenas {price}".replace(
    "{price}",
    `<span>R$5</span>`
  );

  const benefitTextFormatted = (text) => {
    return ReactHtmlParser(text);
  };

  function selectTooltip(text) {
    if (text === currentTooltip) setCurrentTooltip("");
    else setCurrentTooltip(text);
  }

  const textWithIcon = (text) => {
    return text.replace(
      "{icon}",
      '<img src="/tagnext/assets/info_icon_darkgreen.svg" />'
    );
  };

  const bonusText = () => {
		const bonusStart = addHours(new Date('2024-10-15'), 3)
		const bonusEnd = addHours(new Date('2024-12-14'), 3)
		const today = addHours(new Date(), 3)

		const isBetween = isWithinInterval(today, { start: bonusStart, end: bonusEnd });

		if(isBetween) return "*Válido até 14/12/24; depois R$20 por tag."

		return null
  }

  return (
    <S.Container>
      <S.Title>{ReactHtmlParser(titleFormatted)}</S.Title>
      <S.Benefits>
        {benefits.map((benefit, index) => (
          <S.Item key={benefit.text}>
            <img src="/tagnext/assets/check.svg" alt="check" />
            <S.Benefit
              bold={benefit.isBold}
              blur={blur}
              onClick={() => selectTooltip(benefit.text)}
            >
              {benefitTextFormatted(textWithIcon(benefit.text))}
              {benefit.tooltip && (
                <CustomTooltip
                  title={benefit.tooltip.title}
                  description={benefit.tooltip.description}
                  label={ReactHtmlParser(textWithIcon(benefit.tooltip.label))}
                />
              )}
            </S.Benefit>
          </S.Item>
        ))}
      </S.Benefits>
      <S.PromoText>{bonusText()}</S.PromoText>
    </S.Container>
  );
}

export default CardPlan;
